import React from 'react'
import { Field } from 'react-final-form'
import classNames from 'classnames'
import DatePicker from 'react-datepicker'
import dayjs from '../../utilities/dayjs'
import UnderlineSelect from '../underline-select'
import styles from './index.module.scss'
import PropTypes from 'prop-types'
import AddFeesCard from '../add-fees-recurring/AddFeesCard'
import { userSelectOptions } from '../../utilities/randomUtilities'
import { SelectInput } from '../SelectInput'

export default function AssetRecurringFormInputs ({
  name,
  resourceTypes,
  dayOptions,
  feeTypes,
  onRemove,
  form,
  assetIndex,
  users
}) {
  const serviceDateOptions = Array.from({ length: 31 }, (_, i) => ({
    value: i + 1,
    label: String(i + 1)
  }))

  return (
    <div className='dis-rounded-panel'>
      <div className='dis-asset-header'>
        <Field name={`${name}.resourceTypeId`}>
          {({ input }) => (
            <label className='dis-list-item-header'>
              {resourceTypes.find(r => r.id === input.value)?.name || input.value}
            </label>
          )}
        </Field>
        <button type='button' onClick={onRemove}>
          <i className={classNames('material-icons dis-btn-icon', styles.closeIcon)}>clear</i>
        </button>
      </div>

      <div className='dis-form-container padding-1em'>
        <div className='dis-form-row'>
          <Field name={`${name}.serviceInterval`}>
            {({ input, meta }) => (
              <div className='form-group dis-half-width-field'>
                <label className='control-label' htmlFor={`${name}.serviceInterval`}>Select Interval</label>
                <select {...input} className='form-control'>
                  <option value='' />
                  <option value='WEEKLY'>Weekly</option>
                  <option value='MONTHLY'>Monthly</option>
                  <option value='EVERY_X_DAYS'>Every X Days</option>
                </select>
                {meta.touched && meta.error && <span className='text-danger'>{meta.error}</span>}
              </div>
            )}
          </Field>

          <Field name={`${name}.serviceInterval`} subscription={{ value: true }}>
            {({ input: { value } }) => (
              <>
                {value !== 'MONTHLY' && value !== 'EVERY_X_DAYS' && (
                  <Field name={`${name}.serviceDay`}>
                    {({ input, meta }) => (
                      <div className='dis-half-width-field'>
                        <label className='control-label' htmlFor={`${name}.serviceDay`}>Select Service Day(s)</label>
                        <UnderlineSelect
                          placeholder=''
                          inputId={`${name}.serviceDay`}
                          isMulti
                          options={dayOptions}
                          defaultValue={dayOptions.filter(opt => input.value?.includes(opt.value))}
                          onChange={(selectedOptions) => {
                            const selected = selectedOptions?.map(o => o.value) || []
                            input.onChange(selected)
                          }}
                          minWidth={315}
                          closeMenuOnSelect
                        />
                        {meta.touched && meta.error && <span className='text-danger'>{meta.error}</span>}
                      </div>
                    )}
                  </Field>
                )}

                {value === 'MONTHLY' && (
                  <Field name={`${name}.serviceDate`}>
                    {({ input, meta }) => (
                      <div className='dis-half-width-field'>
                        <label className='control-label' htmlFor={`${name}.serviceDate`}>Select Service Date</label>
                        <UnderlineSelect
                          placeholder=''
                          inputId={`${name}.serviceDate`}
                          isMulti
                          options={serviceDateOptions}
                          value={serviceDateOptions.filter(opt =>
                            input.value?.includes(opt.value)
                          )}
                          onChange={(selectedOptions) => {
                            const selected = selectedOptions?.map(o => o.value) || []
                            input.onChange(selected)
                          }}
                          minWidth={315}
                          closeMenuOnSelect
                        />
                        {meta.touched && meta.error && <span className='text-danger'>{meta.error}</span>}
                      </div>
                    )}
                  </Field>
                )}

                {value === 'EVERY_X_DAYS' && (
                  <Field name={`${name}.serviceDailyFrequency`}>
                    {({ input, meta }) => (
                      <div className='dis-half-width-field'>
                        <label className='control-label' htmlFor={`${name}.serviceDailyFrequency`}>Service Daily Frequency</label>
                        <input {...input} type='number' className='form-control' min={1} />
                        {meta.touched && meta.error && <span className='text-danger'>{meta.error}</span>}
                      </div>
                    )}
                  </Field>
                )}
              </>
            )}
          </Field>
        </div>

        <div className='dis-form-row'>
          <Field name={`${name}.startDate`}>
            {({ input, meta }) => {
              const endDate = form?.getState()?.values?.assetDetails[assetIndex]?.endDate
              return (
                <div className={classNames(styles.dateLabel, 'dis-half-width-field')}>
                  <label htmlFor={`${name}.startDate`} className='control-label'>
                    Starting On
                  </label>
                  <DatePicker
                    id={`${name}.startDate`}
                    className={styles.datePicker}
                    dateFormat='MM/dd/yyyy'
                    selected={
                      input.value && dayjs(input.value, 'YYYY-MM-DD', true).isValid()
                        ? dayjs(input.value, 'YYYY-MM-DD').toDate()
                        : null
                    }
                    onChange={(date) =>
                      input.onChange(date ? dayjs(date).format('YYYY-MM-DD') : null)
                    }
                    minDate={new Date()}
                    maxDate={endDate ? dayjs(endDate).toDate() : undefined}
                  />
                  {meta.touched && meta.error && <span className='text-danger'>{meta.error}</span>}
                </div>
              )
            }}
          </Field>

          <Field name={`${name}.endDate`}>
            {({ input, meta }) => {
              const startDate = form?.getState()?.values?.assetDetails[assetIndex]?.startDate
              return (
                <div className={classNames(styles.dateLabel, 'dis-half-width-field')}>
                  <label htmlFor={`${name}.endDate`} className={classNames('control-label dis-half-width-field', styles.dateLabel)}>
                    Ending On
                  </label>
                  <DatePicker
                    id={`${name}.endDate`}
                    className={styles.datePicker}
                    dateFormat='MM/dd/yyyy'
                    selected={
                      input.value && dayjs(input.value, 'YYYY-MM-DD', true).isValid()
                        ? dayjs(input.value, 'YYYY-MM-DD').toDate()
                        : null
                    }
                    onChange={(date) => input.onChange(date ? dayjs(date).format('YYYY-MM-DD') : null)}
                    minDate={startDate ? dayjs(startDate).toDate() : undefined}
                  />
                  {meta.touched && meta.error && <span className='text-danger'>{meta.error}</span>}
                </div>
              )
            }}
          </Field>
        </div>

        <div className='dis-form-row'>
          <div className='dis-half-width-field padding-right-1rem'>
            <Field
              name={`${name}.driverId`}
              label='Assigned Driver'
              alphabetize
              options={userSelectOptions(users)}
              component={SelectInput}
            />
          </div>
        </div>
      </div>

      <AddFeesCard
        asset={name}
        feeTypes={feeTypes}
        form={form}
        assetIndex={assetIndex}
      />
    </div>
  )
}

AssetRecurringFormInputs.propTypes = {
  name: PropTypes.string.isRequired,
  resourceTypes: PropTypes.array.isRequired,
  dayOptions: PropTypes.array.isRequired,
  feeTypes: PropTypes.array.isRequired,
  onRemove: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  assetIndex: PropTypes.number.isRequired,
  users: PropTypes.array
}
